module.exports = __webpack_public_path__ + "static/img/avatar-2.f96bc055.png";